import styled from '@emotion/styled';
import { Tabs } from 'antd';
import { colorConstants } from 'config/colorConstants';

const scenarioTabWidth = '155px';
const scenarioTabInactiveBg = colorConstants.scenarioTabInactiveBg;
const scenarioTabActiveBg = colorConstants.white;
const scenarioTabActiveColor = colorConstants.violet;

export const ScenarioTabLabel = styled.span`
    display: block;
    width: ${scenarioTabWidth};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-align: left;
`;

export const StyledScenarioTabsRow = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 2px;
    width: calc(100% + 32px);
    margin-inline: -16px;
    min-height: 40px;
    background: ${scenarioTabInactiveBg};
`;

export const StyledScenarioTabs = styled(Tabs)`
    width: fit-content;
    max-width: 100%;
    flex: 0 0 auto;
    background: ${scenarioTabInactiveBg} !important;

    & > .ant-tabs-nav {
        margin-bottom: 0 !important;
        width: fit-content;
        max-width: 100%;
        background: ${scenarioTabInactiveBg} !important;

        &::before {
            border-bottom: 0 !important;
        }
    }

    .ant-tabs-nav-wrap,
    .ant-tabs-nav-operations {
        background: ${scenarioTabInactiveBg} !important;
    }

    &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active) {
        background: ${scenarioTabInactiveBg} !important;
    }

    &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active {
        background: ${scenarioTabActiveBg} !important;
        border-radius: 8px 8px 0 0 !important;
    }

    .ant-tabs-nav-wrap {
        width: fit-content !important;
        flex: 0 0 auto !important;
    }

    .ant-tabs-nav-list {
        column-gap: 2px;
    }

    .ant-tabs-tab {
        padding: 8px 16px !important;
        border: 0 !important;
        // border-radius: 6px 6px 0 0 !important;
        margin-right: 0 !important;
        margin-left: 0 !important;
        justify-content: flex-start;
        height: 40px;
        background: ${scenarioTabInactiveBg} !important;
    }

    .ant-tabs-tab .ant-tabs-tab-btn {
        width: ${scenarioTabWidth};
        color: ${colorConstants.greyAlt7};
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        text-align: left;
        overflow: hidden;
    }

    .ant-tabs-tab-active,
    .ant-tabs-tab.ant-tabs-tab-active {
        background: ${scenarioTabActiveBg} !important;
        border-radius: 8px 8px 0 0 !important;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn,
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${scenarioTabActiveColor} !important;
        font-weight: 500;
    }

    .ant-tabs-ink-bar {
        background: ${scenarioTabActiveColor};
        height: 2px;
    }

    .ant-tabs-content-holder {
        display: none;
    }
`;

export const StyledNewScenarioTabButton = styled.button`
    border: 0;
    background: ${scenarioTabInactiveBg};
    padding: 8px 16px;
    height: 40px;
    flex-shrink: 0;
    color: ${colorConstants.purpleFont};
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        color: ${colorConstants.greyAlt7};
        background: ${scenarioTabInactiveBg};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.45;
    }
`;

export const StyledScenarioMetadataSummary = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 16px;
    color: ${colorConstants.blackTransparent88};

    .metadata-label {
        font-weight: 400;
        color: ${colorConstants.greyAlt12};
    }

    .metadata-value {
        font-weight: 400;
        margin-left: 4px;
        color: ${colorConstants.greyAlt12};
    }
`;

export const StyledScenarioPanel = styled.div`
    border: none;

    .toolbar-btn.ant-btn, .toolbar-btn.ant-btn:hover {
        height: 30px;
        border-radius: 6px;
        font-size: 13px;
        border-color: ${colorConstants.toolbarBorderGrey};
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${colorConstants.black};
    }

    .toolbar-icon-btn.ant-btn, .toolbar-icon-btn.ant-btn:hover {
        width: 30px;
        height: 30px;
        border-radius: 6px;
        border-color: ${colorConstants.toolbarBorderGrey};
        padding: 5px;
        color: ${colorConstants.black};
        justify-content: center;
        align-items: center;
        display: flex;
    }

    .toolbar-select.ant-select .ant-select-selector {
        height: 30px !important;
        border-radius: 6px !important;
        border-color: ${colorConstants.toolbarBorderGrey} !important;
    }

    .toolbar-select.ant-select .ant-select-selection-item {
        line-height: 28px !important;
        font-size: 13px;
    }

    .toolbar-search.ant-input-affix-wrapper {
        height: 30px;
        border-radius: 6px;
        border-color: ${colorConstants.toolbarBorderGrey};
    }
`;
